import React from 'react'
import ProductViewriPad from '../iPad/ProductViewr'
import HeroiPad from '../iPad/HeroiPad'
import ShowCaseiPad from '../iPad/VideoCarouseliPad'
import TitleHeading from '../iPad/TitleHeading'
import HowItWorksiPad from '../iPad/HowItWorksiPad'
import PerformanceiPad from '../iPad/PerformanceiPad'
import HighLightsiPad from '../iPad/HighLightsiPad'

const IPad = () => {
    return (
        <div>
            <HeroiPad />
            <ProductViewriPad />
            <TitleHeading />
            <ShowCaseiPad />
            <HowItWorksiPad />
            <PerformanceiPad />
            <HighLightsiPad />
        </div>
    )
}

export default IPad
